<div class="main-content table-page table-page--compact table-page--dense telefonos-page">
  <div class="container-fluid">
    <section class="table-page__hero">
      <div class="table-page__copy">
        <h1>Teléfonos</h1>
        <p>Los equipos con los que su gente registra asistencia.</p>
      </div>
    </section>

    <section class="table-page__card">
      <div class="table-page__toolbar table-page__toolbar--filters">
        <div class="table-page__filters-grid">
          <div class="table-page__filter table-page__filter--wide">
            <mat-form-field appearance="outline" class="table-page__field">
              <mat-label>Persona o equipo</mat-label>
              <input matInput aria-label="Persona o equipo" [(ngModel)]="filtroBusqueda" (keyup.enter)="consultar()" />
            </mat-form-field>
          </div>
          <div class="table-page__filter table-page__filter--medium">
            <mat-form-field appearance="outline" class="table-page__field">
              <mat-label>Estatus</mat-label>
              <mat-select [(ngModel)]="filtroEstatus" (selectionChange)="consultar()">
                <mat-option value="PENDIENTE">Esperan autorización</mat-option>
                <mat-option value="ACTIVO">Autorizados</mat-option>
                <mat-option value="REVOCADO">Dados de baja</mat-option>
                <mat-option [value]="null">Todos</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>

        <div class="table-page__toolbar-actions">
          <button type="button" mat-raised-button class="btn table-page__icon-btn table-page__icon-btn--secondary"
                  (click)="limpiarFiltros()">
            <span class="material-icons">filter_alt_off</span>
            Limpiar
          </button>
          <button type="button" mat-raised-button class="btn table-page__primary-btn" (click)="consultar()">
            <span class="material-icons">search</span>
            Consultar
          </button>
        </div>
      </div>

      <div class="table-page__table-wrap" *ngIf="dispositivos.length > 0; else telefonosEmptyState">
        <table class="table-page__table">
          <thead>
            <tr>
              <th>Persona</th>
              <th>Equipo</th>
              <th>Solicitado</th>
              <th>Último registro</th>
              <th>Estatus</th>
              <th class="table-page__actions-head table-page__actions--multi">Acciones</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let equipo of dispositivos">
              <td>
                <div class="table-page__cell-stack">
                  <strong class="table-page__name">{{ equipo.nombreEmpleado }}</strong>
                  <span class="table-page__subtext">{{ equipo.usuario }}</span>
                </div>
              </td>
              <td><span class="table-page__text">{{ etiquetaEquipo(equipo) }}</span></td>
              <td><span class="table-page__text">{{ soloFecha(equipo.fechaSolicitud) }}</span></td>
              <td><span class="table-page__text">{{ soloFecha(equipo.ultimaVerificacion) }}</span></td>
              <td><span [class]="claseEstatus(equipo.estatus)">{{ etiquetaEstatus(equipo.estatus) }}</span></td>
              <td class="table-page__actions table-page__actions--multi">
                <div class="table-page__action-group">
                  <button type="button" class="table-page__action-btn" title="Autorizar" aria-label="Autorizar"
                          *ngIf="esPendiente(equipo)" (click)="aprobar(equipo)">
                    <span class="material-icons">verified_user</span>
                  </button>
                  <button type="button" class="table-page__action-btn table-page__action-btn--danger"
                          title="Dar de baja" aria-label="Dar de baja"
                          *ngIf="!esRevocado(equipo)" (click)="revocar(equipo)">
                    <span class="material-icons">link_off</span>
                  </button>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <ng-template #telefonosEmptyState>
        <div class="table-page__empty" *ngIf="!loading; else telefonosLoadingState">
          <span class="material-icons">phone_iphone</span>
          <h3>No hay teléfonos que atender</h3>
          <p>Con estos filtros no sale ninguno. Si buscaba solicitudes pendientes, quiere decir que nadie está esperando autorización.</p>
        </div>
      </ng-template>

      <ng-template #telefonosLoadingState>
        <div class="table-page__empty table-page__empty--loading">
          <span class="material-icons">hourglass_top</span>
          <h3>Consultando teléfonos</h3>
          <p>Espere un momento.</p>
        </div>
      </ng-template>
    </section>
  </div>
</div>
